import * as z from "zod";

export const getMetaAdsAccounts = {
  name: "getMetaAdsAccounts" as const,
  input: z.null(),
  output: z.object({
    accounts: z.array(
      z.object({ accountId: z.string(), id: z.string(), name: z.string() }),
    ),
  }),
};
